export const getTextEditor = () => {
  //INFO: legacy logic from original extension, text editor is a flag to check if you are on the outreach website
  return window.location.href.includes("outreach");
};
